@if (buttons$ | async; as buttons) {
  <div>
    @if (!groupByCategory) {
      <div class="facet-buttons">
        @for (button of buttons; track button) {
          <hyperkit-tag
            mode="fill"
            [closable]="closable"
            [textLeft]="button.category"
            [text]="button.value"
            (click)="onButtonClick(button)"
          >
          </hyperkit-tag>
        }
      </div>
    }
  </div>
}
@if (groupByCategory && groupedButtons) {
  <div class="button-container">
    @for (category of groupedButtons | keyvalue; track category) {
      <div class="button-group">
        <hyperkit-typography
          variant="emphasized"
          size="sm"
          align="left"
          color="primary"
          >{{ category.key }}</hyperkit-typography
        >
        <div class="facet-buttons">
          @for (button of category.value; track button) {
            <div class="button">
              <hyperkit-tag
                mode="outline"
                [selected]="button.active"
                [text]="button.value"
                (click)="onButtonClick(button)"
              >
              </hyperkit-tag>
            </div>
          }
        </div>
      </div>
    }
  </div>
}
